var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 23.5C18.3513 23.5 23.5 18.3513 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11C15.5 11.5304 15.2893 12.0391 14.9142 12.4142C14.5391 12.7893 14.0304 13 13.5 13C12.9696 13 12.4609 12.7893 12.0858 12.4142C11.7107 12.0391 11.5 11.5304 11.5 11V7C11.5 6.46957 11.7107 5.96086 12.0858 5.58579C12.4609 5.21071 12.9696 5 13.5 5C14.0304 5 14.5391 5.21071 14.9142 5.58579C15.2893 5.96086 15.5 6.46957 15.5 7V11Z",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.58106 13C8.52019 13 7.50277 12.5786 6.75263 11.8284C6.00248 11.0783 5.58105 10.0609 5.58105 9C5.58105 7.93913 6.00248 6.92172 6.75263 6.17157C7.50277 5.42143 8.52019 5 9.58106 5",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.17 14.493C16.2665 14.2039 16.4515 13.9524 16.6988 13.7742C16.9461 13.596 17.2432 13.5001 17.548 13.5V13.5C17.7388 13.5 17.9277 13.5376 18.1039 13.6106C18.2801 13.6837 18.4402 13.7907 18.5751 13.9256C18.7099 14.0606 18.8168 14.2208 18.8898 14.397C18.9627 14.5733 19.0001 14.7622 19 14.953C19 15.3033 18.8607 15.6393 18.613 15.887L16 18.5H19",
    stroke: "#040C1E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCo2);
export default __webpack_public_path__ + "static/media/CO2.0bbc963b156457ac6996135cdd71f5de.svg";
export { ForwardRef as ReactComponent };